// Helpers for the staff customer profile page (pure; easy to test).

// The pause and status endpoints return the raw customer record. Merge it
// into the page data so the computed fields from GET /customers/:id
// (computedStatus, lastVisitAt, lifetimeSpend, totalBookings, ...) stay.
// Replacing the page data with the raw record wiped them until the next
// 30-second refresh.
export const mergeCustomerRecord = (previous, record) =>
  record ? { ...(previous || {}), ...record } : previous;

// The Membership Pause card shows only when the customer has a membership
// (active or paused) or a pause is already set.
export const hasPausableMembership = (customer, creditSummary) => {
  if (!customer) return false;
  if (["paused", "scheduled_pause"].includes(customer.membershipAccessStatus)) {
    return true;
  }
  if (creditSummary?.rows) {
    return creditSummary.rows.some((row) => row.category === "membership");
  }
  const active = (status) => status === "active" || status === "trialing";
  const has = (value) => value && String(value).toLowerCase() !== "none";
  return Boolean(
    (has(customer.saunaMembershipType) && active(customer.saunaMembershipStatus)) ||
      (has(customer.redLightMembershipType) && active(customer.redLightMembershipStatus)) ||
      (has(customer.sharedMembershipName) &&
        customer.sharedMembershipCurrentPeriodEnd &&
        new Date(customer.sharedMembershipCurrentPeriodEnd) > new Date())
  );
};
